import { errorMessageAlert } from '@/helpers/alert'

// mixins errorHandlerMixins
export default {
  methods: {
    // Cette méthode a pour but de créer le message d'erreur à afficher
    // Si elle retourne une chaîne vide, alors il faudra afficher le message d'erreur par défaut
    getTextError (err) {
      if (!err.response || !err.response.data.errors) { // Error 500
        errorMessageAlert(err, this)
        return ''
      } else { // Error 400
        // Liste des labels d'erreurs
        let errList = []
        err.response.data.errors.forEach(line => {
          if (line.errorCode && this.$t(`errors.${line.errorCode}`) !== `errors.${line.errorCode}`) { // Si l'erreur contient un errorCode [et que son label existe], alors on ajoute le label correspondant
            errList.push(this.$t(`errors.${line.errorCode}`))
          } else { // Sinon on ajoute le label fournit par la modélisation
            errList.push(line.errorDescription)
          }
        })
        let errors = errList.join('<br>')
        return errors
      }
    },
    // Cette méthode gère une erreur : elle affiche le message d'erreur sous forme de pop-up
    handleError (err) {
      let message = this.getTextError(err) // mixins errorHandlerMixins
      if (message !== '') {
        this.$f7.alert(message, this.$t('errors.error_label'))
      } // Else message d'erreur générique (géré ailleurs dans l'appli)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/errorHandlerMixin.js